import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RouteName } from './routing-path';
import { LoginGuard } from './route-guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: `/${RouteName.DEFAULT_ORGANISATION_ID}/${RouteName.HOME}`,
    pathMatch: 'full',
  },
  {
    path: `${RouteName.AUTH}`,
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthPageModule),
  },
  {
    path: `${RouteName.LOGOUT}`,
    loadChildren: () => import('./logout/logout.module').then(m => m.LogoutPageModule),
  },
  {
    path: `${RouteName.ORGANISATIONS}`,
    loadChildren: () => import('./organisations-setup/organisations-setup.module').then(m => m.OrganisationsPageModule)
  },
  {
    path: `${RouteName.INVITE}`,
    loadChildren: () => import('./invite-setup/invite-setup.module').then(m => m.InviteSetupPageModule)
  },
  {
    path: `${RouteName.OAUTH}`,
    loadChildren: () => import('./oauth/oauth.module').then(m => m.OauthPageModule)
  },
  {
    path: ':oid',
    children: [
      {
        path: `${RouteName.HOME}`,
        loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
        canActivate: [LoginGuard],
      },
      {
        path: '',
        redirectTo: `${RouteName.HOME}`,
        pathMatch: 'full',
      },
      {
        path: `${RouteName.CONTACTS}`,
        loadChildren: () => import('./contacts/contacts.module').then(m => m.ContactsPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.CONTACTS}/${RouteName.CONTACT}/:${RouteName.CONTACT_ID}`,
        loadChildren: () => import('./contact/contact.module').then(m => m.ContactPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.DEALS}`,
        loadChildren: () => import('./deals/deals.module').then(m => m.DealsPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.TASKS}`,
        loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.PRODUCTS}`,
        loadChildren: () => import('./products/products.module').then(m => m.ProductsPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.DEALS}/${RouteName.DEAL}/${RouteName.DEAL_ID}`,
        loadChildren: () => import('./deal/deal.module').then(m => m.DealPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.PRODUCTS}/${RouteName.PRODUCT}/${RouteName.PRODUCT_ID}`,
        loadChildren: () => import('./product/product.module').then(m => m.ProductPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.COMPANIES}`,
        loadChildren: () => import('./companies/companies.module').then(m => m.CompaniesPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.COMPANIES}/${RouteName.COMPANY}/${RouteName.COMPANY_ID}`,
        loadChildren: () => import('./company/company.module').then(m => m.CompanyPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.CALLS}`,
        loadChildren: () => import('./calls/calls.module').then(m => m.CallsPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.BROADCASTS}`,
        loadChildren: () => import('./broadcasts/broadcasts.module').then(m => m.BroadcastsPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.BROADCASTS}/${RouteName.BROADCAST}/${RouteName.BROADCAST_ID}`,
        loadChildren: () => import('./broadcast/broadcast.module').then(m => m.BroadcastPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.REPORTS}`,
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.SEARCH}`,
        loadChildren: () => import('./search/search.module').then(m => m.SearchPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.AUTOMATIONS}`,
        loadChildren: () => import('./automations/automations.module').then(m => m.AutomationsPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.AUTOMATIONS}/${RouteName.WORKFLOW}/:${RouteName.WORKFLOW_ID}`,
        loadChildren: () => import('./workflow/workflow.module').then(m => m.WorkflowPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.MARKETPLACE}`,
        loadChildren: () => import('./marketplace/marketplace.module').then(m => m.MarketplacePageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.HELP}`,
        loadChildren: () => import('./help/help.module').then(m => m.HelpPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.SETTINGS}`,
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsPageModule),
        canActivate: [LoginGuard],
      },
      {
        path: `${RouteName.FEEDBACK}`,
        loadChildren: () => import('./feedback/feedback.module').then(m => m.FeedbackPageModule)
      },
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
